import { z } from "zod";

export const examTypeCodeSchema = z.string().brand<"ExamTypeCode">();
export type ExamTypeCode = z.infer<typeof examTypeCodeSchema>;

export const examSubjectCodeSchema = z.string().brand<"ExamSubjectCode">();
export type ExamSubjectCode = z.infer<typeof examSubjectCodeSchema>;

export const examResultCodeSchema = z.string().brand<"ExamResultCode">();
export type ExamResultCode = z.infer<typeof examResultCodeSchema>;
